import { Auth } from "aws-amplify";

export default async ({ user, password }) =>
  Auth.completeNewPassword(user, password);
